import { render, staticRenderFns } from "./LandscapeWarning.vue?vue&type=template&id=1396ea54&scoped=true"
import script from "./LandscapeWarning.vue?vue&type=script&lang=js"
export * from "./LandscapeWarning.vue?vue&type=script&lang=js"
import style0 from "./LandscapeWarning.vue?vue&type=style&index=0&id=1396ea54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1396ea54",
  null
  
)

export default component.exports